module.exports = __webpack_public_path__ + "static/img/cervicalPain_1.d68728cb.png";